import { CourseType } from '../../../types'
import { getCourseCompletedLessons, getCourseLessons } from '.'

export const getCourseCompletedPercentage = (course?: CourseType) => {
  if (!course?.modules) {
    return 0
  }

  const allLessons = getCourseLessons(course)
  const completedLessons = getCourseCompletedLessons(course)

  const quotient = completedLessons.length / allLessons.length
  return quotient * 100
}
